import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dispatch, SetStateAction, useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";

interface CameraUploaderProps {
    setImageURL: Dispatch<SetStateAction<string | null>>
    dialogVisible: boolean
    setDialogVisible: Dispatch<SetStateAction<boolean>>
}

export const IMAGE_MIME_TYPE = "image/png";

const CameraUploader = ({ setImageURL, dialogVisible, setDialogVisible }: CameraUploaderProps) => {
    const [cameraError, setCameraError] = useState<string | null>(null);

    const videoConstraints = {
        facingMode: "environment",
    };

    const webcamRef = useRef<Webcam>(null);

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current?.getScreenshot();
        if (imageSrc) {
            setImageURL(imageSrc);
            setDialogVisible(false);
        }
    }, [setImageURL]);

    const footer = () => (
        <Button
            label="Capturar"
            rounded
            className="w-full"
            onClick={capture}
            disabled={!!cameraError}
        />
    );

    return (
        <Dialog
            visible={dialogVisible}
            onHide={() => {
                setCameraError(null);
                setDialogVisible(false);
            }}
            footer={footer}
            header="Tirar Fotografia"
            headerStyle={{paddingTop: "max(1.25rem, env(safe-area-inset-top, 0px))"}}
            className="w-full md:w-30rem"
            maximized
        >
            <div className="flex flex-column h-full justify-content-center">
                {cameraError && (
                    <p className="text-red-500 text-sm">{cameraError}</p>
                )}
                <Webcam
                    ref={webcamRef}
                    audio={false}
                    screenshotFormat={IMAGE_MIME_TYPE}
                    videoConstraints={videoConstraints}
                    className="border-round-lg"
                    style={{ width: "100%", height: "auto" }}
                    onUserMediaError={(err) => {
                        console.error("Webcam error:", err);
                        setCameraError("Não foi possível aceder à câmara. Verifique as permissões.");
                    }}
                />
            </div>
        </Dialog>
    );
};

export default CameraUploader;